import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@material-ui/core';

import { IActionsMenuProps } from './interfaces';

const ActionsMenu: React.FC<IActionsMenuProps> = ({
  actionItems,
  icon: Icon,
}: IActionsMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null);

  const handleOpen = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        data-cy="action-menu__button--icon"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleOpen}
      >
        <Icon color="primary" />
      </IconButton>
      <Menu
        data-cy="action-menu__container--menu"
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={!!anchorEl}
        onClose={handleClose}
      >
        {actionItems.map(({ label, onClick }) => (
          <MenuItem
            data-cy="action-menu__button--menu-item"
            key={label}
            onClick={() => {
              onClick();
              handleClose();
            }}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default ActionsMenu;
